import { Link } from "react-router-dom";
import type { Movie } from "@/types/media";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} 剧情介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-secondary-950/75 text-accent-400 text-xs font-label font-semibold">
          {movie.rating.toFixed(1)}
        </span>
        {movie.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-secondary-950 text-xs font-label font-semibold">
            新
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-500 truncate">
          {movie.year} · {movie.genres.join(" / ")}
        </p>
        <p className="mt-1 text-xs text-foreground-400 truncate">
          {movie.actors.map((a) => a.name).join("、")}
        </p>
      </div>
    </Link>
  );
}